<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="width: 50%;">
                <div class="modal-header">
                    <h3 class="form-header">Add Clinical Reading</h3>
                    <button @click="closeModal()" class="red-close-button">
                        <i class="pi pi-times" style="padding: 0"></i>
                    </button>
                </div>
                
                <div class="modal-body">
                    <slot name="body">
                        <div style="padding: 20px;">
                            <!-- Sedation is the only reading whose input isn't numeric; the rest are
                                 ReadingPanel driven straight off readingType. -->
                            <SedationPanel v-if="readingType === 'sedation'" :patientId="patientId" @readingCompleted="onReadingCompleted" />
                            <ReadingPanel v-else :panelType="readingType" :patientId="patientId" @readingCompleted="onReadingCompleted" />
                        </div>
                    </slot>
                </div>

                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 5px 20px;">
                    <slot name="footer" style="display: flex; gap: 10px">
                        <button class="black-button" style="margin-left: 10px;" @click="closeModal()">
                           Close
                        </button>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SedationPanel from '@/components/administration/SedationPanel.vue';
import ReadingPanel from '@/components/administration/ReadingPanel.vue';

export default {
    props: {
        readingType: {
            type: String,
            required: true
        },
        patientId: {
            type: String,
            required: true
        }
    },
    components: {
        SedationPanel,
        ReadingPanel
    },
    methods: {
        closeModal() {
            this.$emit('close', true);
        },
        onReadingCompleted(value) {
            this.$emit('readingCompleted', value);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";
</style>
